export function routeAuth(route: string) {
  route = route?.startsWith('/') ? route.substring(1) : route;
  if (globalThis.MAX_ROUTES && route) {
    const routes = Object.keys(globalThis.MAX_ROUTES);
    if (!routes.includes(route)) {
      if (globalThis?.$routeAuth) globalThis.$routeAuth?.('undefined');
      return false;
    }
    return true;
  }
  return true; // 产物
}
